import TwitterShareIcon from '~/assets/icons/Twitter';

import Tracked from '../Tracked';

const ShareToTwitter = ({ text }: { text: string }) => {
  const href = `https://twitter.com/intent/tweet?text=${text}`;

  function onClick() {
    window.open(
      href,
      'popUpWindow',
      'height=500,width=400,left=100,top=100,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes'
    );
  }

  return (
    <Tracked.Button
      variant="none"
      onClick={onClick}
      className="cursor-pointer"
      name="SHARE_TO_TWITTER"
      pagePosition="Body"
    >
      <TwitterShareIcon height="24" width="24" fill="black" />
    </Tracked.Button>
  );
};

export default ShareToTwitter;
